import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { FormControl } from '../../../../../../../ui/components/pure/form-control/form-control.component';
import { TextField } from '../../../../../../../ui/components/pure/text-field/text-field.component';
import { useMobilePhoneFormatter } from '../../../../../../../ui/formatters/mobile-phone.formatter';
import { mobilePhoneValidator } from '../../../../../../../ui/util/mobile-phone.validator';
import validateEmail from 'validator/lib/isEmail';
import { Checkbox } from '../../../../../../../ui/components/pure/checkbox/checkbox.component';
import { SectionTitle } from '../../shared-components/section-title/section-title.component';
import _ from 'lodash';
import { useBookOrderActionContext } from '../../book-order-action.context';
import { FreeSoloAutocomplete } from '../../../../../../../ui/components/pure/autocomplete/freesolo-autocomplete.component';

export function NewCustomerForm() {
  const { groupOptions, bookOrderStepForm, state, handlers } = useBookOrderActionContext();
  const form = bookOrderStepForm.watch('createCustomerForm');

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const mobilePhoneFormatter = useMobilePhoneFormatter(state.projectID);

  function onFocusNewCustomerForm() {
    if (state.current === 'BOOK_ORDER' && state.selectedCustomer.isExisting) {
      handlers.onSelectCustomer({ isExisting: false });
    }
  }

  if (state.current !== 'BOOK_ORDER') {
    return null;
  }
  return (
    <div onClick={onFocusNewCustomerForm} style={{ paddingRight: '8px' }}>
      <SectionTitle style={{ paddingTop: '6px' }} value="New Customer" />
      <Grid container style={{ maxWidth: '560px', paddingTop: '8px' }} spacing={2}>
        <Grid container direction="row" wrap="nowrap" spacing={1}>
          <Grid size={6}>
            <FormControl
              control={bookOrderStepForm.control}
              name="createCustomerForm.firstName"
              required={state.selectedCustomer.isExisting === false}
              Component={TextField}
              ComponentProps={{
                textFieldVariant: 'floating' as const,
                placeholder: 'First name',
                fullWidth: true,
                desktopWidth: '100%'
              }}
            />
          </Grid>
          <Grid size={6}>
            <FormControl
              control={bookOrderStepForm.control}
              name="createCustomerForm.lastName"
              Component={TextField}
              ComponentProps={{
                textFieldVariant: 'floating' as const,
                placeholder: 'Last name',
                fullWidth: true,
                desktopWidth: '100%'
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormControl
              control={bookOrderStepForm.control}
              name="createCustomerForm.mobile"
              rules={{
                validate: (mobile) => !mobile || mobilePhoneValidator(mobile)
              }}
              setValueAs={mobilePhoneFormatter}
              required={_.isEmpty(form.email) && state.selectedCustomer.isExisting === false}
              Component={TextField}
              ComponentProps={{
                textFieldVariant: 'floating' as const,
                placeholder: 'Mobile',
                type: 'tel',
                fullWidth: true,
                desktopWidth: '100%'
              }}
            />
          </Grid>
          <Grid size={12}>
            <FormControl
              control={bookOrderStepForm.control}
              name="createCustomerForm.email"
              rules={{
                validate: (email) => (!!email && !validateEmail(email) ? 'Email must be a valid email address' : true)
              }}
              required={_.isEmpty(form.mobile) && state.selectedCustomer.isExisting === false}
              Component={TextField}
              ComponentProps={{
                textFieldVariant: 'floating' as const,
                placeholder: 'Email address',
                type: 'email',
                fullWidth: true,
                desktopWidth: '100%'
              }}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" wrap="wrap" spacing={1}>
          <Grid
            size={{
              xs: 12,
              md: 6
            }}
          >
            <FreeSoloAutocomplete
              control={bookOrderStepForm.control as any}
              fullWidth={isSm}
              name="createCustomerForm.groupName"
              label="Group"
              // groupOptions should be string[] for freeSolo to work
              options={groupOptions}
              inputStyles={{
                width: isSm ? '100%' : 180
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6
            }}
          >
            <div></div>
            <Checkbox
              control={bookOrderStepForm.control as any}
              name="createCustomerForm.prefersLowerLockers"
              label="Prefers lower lockers"
              style={{ paddingTop: '8px' }}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
